import { Button, Col, Row, Space, Typography } from 'antd';
import { ReactNode } from 'react';
import { PencilSquareIcon } from '../../../../shared/icons/pencil-square-icon';
import IconWrapper from '../../../../shared/components/icon-wrapper/icon-wrapper';
import styles from './request-preview-content-data.module.css';

interface Props {
  contentData: {
    title: ReactNode;
    data: ReactNode;
    hidden?: boolean;
    onEdit?: () => void;
  }[];
}

const RequestPreviewContentData = ({ contentData }: Props): JSX.Element => {
  return (
    <Row className={styles.previewDataRow}>
      {contentData
        .filter(content => !content.hidden)
        .map((content, index) => {
          return (
            <Col key={index} xs={24} md={8} className={styles.previewDataColumn}>
              <Space wrap={true} size={[5, 5]}>
                {content.title && (
                  <>
                    <Typography.Text>{content.title}:</Typography.Text>
                    <div>
                      <Typography.Text className={styles.data}>{content.data || '-'}</Typography.Text>
                      {content?.onEdit && (
                        <Button
                          onClick={content?.onEdit}
                          type="text"
                          size="small"
                          shape="circle"
                          icon={
                            <IconWrapper>
                              <PencilSquareIcon className={styles.squareIcon} />
                            </IconWrapper>
                          }
                        />
                      )}
                    </div>
                  </>
                )}
              </Space>
            </Col>
          );
        })}
    </Row>
  );
};

export default RequestPreviewContentData;
